import React from "react";
// import "./styles.css";
import "@google/model-viewer/dist/model-viewer";

export default function ModelViewer({file_path, camera_orbit}) {
  return (
    <div id="card">
      <model-viewer
        src={process.env.PUBLIC_URL + '/' + file_path}
        // exposure="1"
        style={{'background-color': "#404040"}}
        camera-orbit={camera_orbit}
        auto-rotate
        camera-controls
      ></model-viewer>
    </div>
  );
}